import React, { PropsWithChildren } from 'react';
import Skeleton from '@alfa-retail-react/components/skeleton';
import classNames from 'classnames';
import 'app/component/skeleton/section/SectionSkeleton.less';

export interface SectionSkeletonProps {
    /**
     * CSS класс.
     */
    className?: string;
}

/**
 * Скелетон компонента секции.
 * Состоит из заголовка и контента.
 */
export const SectionSkeleton = (
    props: PropsWithChildren<SectionSkeletonProps>,
) => {
    const className = classNames('sectionSkeleton', props.className);

    return (
        <div className={className}>
            <Skeleton className={'title'} visible animate />

            <div className={'content'}>{props.children}</div>
        </div>
    );
};
